<mat-card class="form-card" [formGroup]="formRecipe" *ngIf="recipeOriginal">
  <div style="display: flex; margin-bottom: 20px">
    <app-media-upload
      [usePlaceHolderPicture]="true"
      [withUrlInput]="true"
      [formControlName]="'resourceMedias'"
      [width]="200"
      [height]="120"
      [singleImage]="true"
      (closeMedia)="closeMediaUpload()"
    ></app-media-upload>
    <div class="space-l-s space-r-m">
      <div id="RecipesModifyHeaderClassificationLbl">
        <span *ngFor="let course of formRecipe.controls.courses.value; let isLast = last"
          >{{ getName(course, courseTypesList) }}{{ isLast ? '' : ', ' }}</span
        >
      </div>

      <div class="title-container">
        <div
          matTooltip="{{ 'CLICK_EDIT' | translate }}"
          id="RecipesModifyHeaderTitleBtn"
          class="title"
          (click)="editTitles()"
          (keydown.enter)="editTitles()"
        >
          <h1 id="RecipesModifyHeaderTitlelbl" [innerHtml]="getTitle()"></h1>
        </div>
        <div class="icons">
          <i class="fas fa-pen space-l-s" aria-hidden="true"></i>
          <button *ngIf="isEditSoftHyphenAllowed$ | async" mat-button (click)="toggleSoftHyphen()">Afficher/Masquer Soft Hyphen</button>
        </div>
      </div>

      <div class="space-v-m" *ngIf="formRecipe.controls.partner.value">
        {{ 'PARTNER_WITH' | translate }} <span class="bold">{{ getNamePartner(formRecipe.controls.partner.value, partnersList) }}</span>
      </div>
      <mat-chip-listbox>
        <mat-chip id="RecipesModifyHeaderTopRecipeFidLbl">{{ 'TOP_RECIPE' | translate }}{{ recipeOriginal.topRecipeId }} </mat-chip>
        <mat-chip *ngIf="recipeOriginal && recipeOriginal.brand">
          {{ recipeOriginal.recipeType === 'UGC' ? 'UGC' : recipeOriginal.brand.name }}
        </mat-chip>
        <mat-chip id="RecipesModifyHeaderDomainbl">{{ getName(formRecipe.controls.domain.value, domainsList) }} </mat-chip>
        <mat-chip id="RecipesModifyHeaderMarketLbl">{{ getName(formRecipe.controls.market.value, marketsList) }} </mat-chip>
        <mat-chip id="RecipesModifyHeaderLangLbl">{{ getName(formRecipe.controls.lang.value, languagesList) }} </mat-chip>
        <mat-chip *ngIf="recipeOriginal.isReworked">{{ 'REWORKED' | translate }}</mat-chip>
      </mat-chip-listbox>
    </div>
  </div>

  <a
    id="RecipesModifyHeaderBackOldBoBtn"
    *ngIf="displayCTAOldRecipeScreen$ | async"
    class="btn-old-interface"
    [href]="'/#/recipes/edit/' + recipeOriginal.identifier.sourceSystem + '/' + recipeOriginal.identifier.functionalId"
  >
    <button mat-button class="btn btn-submit" type="button">
      <em class="fas fa-exchange-alt space-h-l"></em>{{ 'TOOLTIPS_OLD_INTERFACE_RECIPE' | translate }}
    </button>
  </a>

  <div class="number-info-list">
    <i
      class="fas fa-mitten space-l-xl space-h-s"
      matTooltip="{{ 'TOOLTIPS_RECIPE_DIFFICULTY' | translate }}"
      matTooltipClass="tooltip-main"
      aria-hidden="true"
    ></i>
    <span *ngIf="!recipeOriginal?.difficulty">{{ 'UNDEFINED' | translate }}</span>
    <span *ngIf="recipeOriginal?.difficulty as difficulty">{{ math.round((difficulty / 100) * 4) }} / 4</span>
    <i
      class="fas fa-euro-sign space-l-xl space-h-s"
      matTooltip="{{ 'TOOLTIPS_RECIPE_COST' | translate }}"
      matTooltipClass="tooltip-main"
      aria-hidden="true"
    ></i>
    <span *ngIf="!recipeOriginal?.cost">{{ 'UNDEFINED' | translate }}</span>
    <span *ngIf="recipeOriginal?.cost as cost">{{ math.round((cost / 100) * 3) }} / 3</span>
    <i
      class="fas fa-star space-l-xl space-h-s"
      matTooltip="{{ 'TOOLTIPS_RECIPE_RATING' | translate }}"
      matTooltipClass="tooltip-main"
      aria-hidden="true"
    ></i>
    <span *ngIf="!recipeOriginal?.community?.rating">{{ 'NO_RATING' | translate }}</span>
    <span *ngIf="recipeOriginal?.community?.rating as rating">{{ rating | number: '1.0-2' }} ({{ recipeOriginal.community.raters }})</span>
    <i
      class="fas fa-credit-card space-l-xl space-h-s"
      matTooltip="{{ 'TOOLTIPS_RECIPE_PREMIUM' | translate }}"
      matTooltipClass="tooltip-main"
      aria-hidden="true"
    ></i>
    <span *ngIf="!recipeOriginal?.isPremium">{{ 'FREE' | translate }}</span>
    <span *ngIf="recipeOriginal?.isPremium">{{ 'PREMIUM' | translate }}</span>
    @if (recipeOriginal.isAIGenerated) {
      <i
        class="fas fa-magic-wand-sparkles space-l-xl space-h-s"
        matTooltip="{{ 'TOOLTIPS_RECIPE_AI_GENERATED' | translate }}"
        matTooltipClass="tooltip-main"
        aria-hidden="true"
      ></i>
      <span>{{ 'GENERATED_WITH_AI' | translate }}</span>
    }
    <div class="action-list">
      <!-- Manage binaries button -->
      <ng-container *ngIf="recipeOriginal?.domain === BINARY_TARGET_DOMAIN">
        <button mat-icon-button (click)="manageBinaries()" matTooltip="{{ 'BINARIES.DOWNLOAD' | translate }}">
          <i class="fas fa-file-archive recipe-icon"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="(isReworkAllowed$ | async) && recipeOriginal.recipeType === 'BRAND'">
        <button mat-icon-button class="recipe-btn-rework" (click)="reworkRecipe()" matTooltip="{{ 'REWORK_RECIPES.TOOLTIP' | translate }}">
          <mat-icon class="recipe-icon-rework">check-circle</mat-icon>
        </button>
      </ng-container>
      <button
        mat-icon-button
        (click)="copyRecipe()"
        id="RecipesModifyHeaderCopyRecipeBtn"
        matTooltip="{{ 'COPY_RECIPES.BTN' | translate }}"
      >
        <i class="fas fa-copy recipe-icon"></i>
      </button>
    </div>
  </div>
  <div class="form-field-maxi divider">
    <br />
    <mat-divider></mat-divider>
    <br />
  </div>
  <mat-accordion>
    <mat-expansion-panel
      id="RecipesModifyClassificationBtn"
      #classificationsPanel
      class="mat-elevation-z0"
      (opened)="panelClassificationsState = true"
      (closed)="panelClassificationsState = false"
      [disabled]="disableClassificationsFolding"
    >
      <mat-expansion-panel-header class="general-informations">
        <mat-panel-title>
          <h4 class="classifications space-t-m">{{ 'RECIPE_CLASSIFICATIONS' | translate }}</h4>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-tab-group #tabGroup (selectedTabChange)="beforeTabChange($event)">
          <mat-tab label="{{ 'USERS.CLASSIFICATIONS.ADVANCED' | translate }}">
            <app-classifications
              [recipeOriginal]="recipeOriginal"
              [abacusType]="typeAbaque"
              [isReworkAllowed]="(isReworkAllowed$ | async) || false"
              (classificationsDirty)="disableClassificationsFolding = $event"
              (updateRecipe)="saveClassifications($event)"
              (mediaUpdateEvent)="mediaUpdateEvent($event)"
              (formDirtyState)="onFormDirtyStateChanged($event)"
              (isAIGeneratedChange)="onAIGeneratedChange($event)"
            ></app-classifications>
          </mat-tab>
          <mat-tab label="{{ 'SEO.TITLE_GROUP' | translate }}" id="RecipesModifyClassificationSEOBtn">
            <app-seo
              [recipeOriginal]="recipeOriginal"
              [isSeoURLDisabled$]="isSeoURLDisabled$"
              (updateRecipe)="saveSeo($event)"
              (formDirtyState)="onFormDirtyStateChanged($event)"
            ></app-seo>
          </mat-tab>
          <mat-tab label="{{ 'EDITO.TITLE_GROUP' | translate }}" id="RecipesModifyClassificationEditoBtn">
            <ng-template matTabContent>
              <app-edito
                [recipeOriginal]="recipeOriginal"
                (updateRecipe)="saveEdito($event)"
                (formDirtyState)="onFormDirtyStateChanged($event)"
                >>
              </app-edito>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</mat-card>
